import { Flex, FormControl, FormLabel, Input } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FieldPassengersProps } from "./interface";
import TextRequired from "../TextRequired";
import update from "immutability-helper";

const FieldPassengers: React.FC<FieldPassengersProps> = ({
  value,
  number,
  onChange,
  isError,
}) => {
  const [passengers, setPassengers] = useState<string[]>([]);

  useEffect(() => {
    setPassengers(
      Array.from({ length: number }, (elm, index) =>
        value ? value[index] || "" : ""
      )
    );
  }, [number, setPassengers, value]);

  const onInputChange = (index: number, value: string) => {
    const newValue = update(passengers, {
      [index]: {
        $set: value,
      },
    });

    setPassengers(newValue);

    onChange(newValue);
  };

  return (
    <Flex flexDirection="column" gap={2}>
      {passengers.map((passenger, index) => (
        <FormControl
          as={Flex}
          isInvalid={isError && !passenger}
          key={index}
          gap={4}
          mb={0}
        >
          <FormLabel minW="25%" fontSize="sm">
            Passenger {index + 1}
            <TextRequired>*</TextRequired>
          </FormLabel>
          <Input
            value={passenger}
            onChange={(e) => onInputChange(index, e.target.value)}
          />
        </FormControl>
      ))}
    </Flex>
  );
};

export default FieldPassengers;
